module.exports = __webpack_public_path__ + "img/dashboard.adf027c8.svg";